import { Outlet } from "react-router-dom";

const UserProgramRequestLayout = () => {
  return <Outlet />;
};

export default UserProgramRequestLayout;